import { render, staticRenderFns } from "./temhead2.vue?vue&type=template&id=4262aa67&scoped=true"
import script from "./temhead2.vue?vue&type=script&lang=js"
export * from "./temhead2.vue?vue&type=script&lang=js"
import style0 from "./temhead2.vue?vue&type=style&index=0&id=4262aa67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4262aa67",
  null
  
)

export default component.exports